const PLANS_KEYS = {
  PLANS: () => ['plans'],
};

export default PLANS_KEYS;
